import ShopgateTrackingGaNativeInit from '@shopgate/tracking-ga-native/frontend/index.js';
import ShopgateTrackingFirebaseInit from '@shopgate/tracking-firebase/frontend/index.js';
import ShopgateTrackingShopgateAnalyticsInit from '@shopgate/tracking-shopgate-analytics/frontend/src/index.js';

export default {
  '@shopgate/tracking-ga-native/init': ShopgateTrackingGaNativeInit,
  '@shopgate/tracking-firebase/init': ShopgateTrackingFirebaseInit,
  '@shopgate/tracking-shopgate-analytics/init': ShopgateTrackingShopgateAnalyticsInit,
};
